import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { AppConfig } from "../config/app.config";

import { RootReducer } from "./root.reducer";

const persistConfig = {
    key: 'mindshield',
    storage
};

const persistedReducer = persistReducer(persistConfig, RootReducer);

const middleware = () => {
    const middleware = [];

    if (AppConfig.app.isLocal) {
        const logger = createLogger();
        middleware.push(logger);
    };

    return middleware;
};

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(middleware()),
});

const persistor = persistStore(store);

export { store, persistor };